import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyType } from '@bciti/types';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'localizeCurrency',
    pure: false,
})
export class LocalizeCurrencyPipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(value, currency: CurrencyType = CurrencyType.CAD) {
        return new Intl.NumberFormat(this.translate.currentLang, {
            style: 'currency',
            currency: currency,
            currencyDisplay: 'narrowSymbol',
        } as any).format(value);
    }
}
